<template>
  <div>
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="9"
        md="8"
      >
        <v-form @submit="create">
          <v-card class="elevation-12">
            <v-toolbar
              color="primary"
              dark
              flat
            >
              <v-toolbar-title>Kandidatúra poslanca NR SR</v-toolbar-title>
              <v-spacer />
            </v-toolbar>
            <v-card-text v-if="user.candidate_approved == false">
              Tvoja žiadosť bola daná <strong>na schválenie</strong>. Po schválení budeš viditeľný v zozname kandidátov.
            </v-card-text>
            <v-card-text v-if="user.candidate_approved == true">
              Tvoja žiadosť bola <strong>schválená</strong>. Si viditeľný v zozname kandidátov.
            </v-card-text>
            <v-card-text v-else-if="user.candidate_id">
              V prípade aktualizácie žiadosti bude Tvoja kandidatúra daná na
              opätovné schválenie administrátorom. </v-card-text>
            <v-card-text
              v-if="user.verified && !initialLoading && !initialLoadFailed"
              data-test="candidate-form-content"
            >
              <v-text-field
                v-model="form.short_info"
                label="Krátke info"
                placeholder="Napíš krátke informácie o sebe, ktoré sa budú zobrazovať pri tvojej kandidatúre"
                name="short_info"
                prepend-icon="mdi-account"
                type="text"
              >

                <template v-slot:prepend>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    Napíš krátke informácie o sebe, ktoré sa budú zobrazovať pri tvojej kandidatúre
                  </v-tooltip>
                </template>
              </v-text-field>

              <v-textarea
                auto-grow
                rows="2"
                v-model="form.long_info"
                label="Dlhé info"
                placeholder="Napíš niečo o sebe, niečo o čom si myslíš, že podporí tvoju kandidatúru a prinesie Ti hlasy"
                name="long_info"
                type="text"
              > <template v-slot:prepend>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    Napíš niečo o sebe, niečo o čom si myslíš, že podporí tvoju kandidatúru a prinesie Ti hlasy
                  </v-tooltip>
                </template>
              </v-textarea>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-file-input
                    v-model="photo_file"
                    accept="image/*"
                    label="Fotografia - sem vlož svoju fotografiu, ktorá sa bude zobrazovať pri tvojom profile kandidáta. Dávaj pozor na výber, lebo aj fotografia naznačuje niečo o osobnosti na fotografii"
                    v-bind="attrs"
                    v-on="on"
                    @mouseenter.native="on.mouseenter"
                    @mouseleave.native="on.mouseleave"
                  ></v-file-input>
                </template>
                <span>
                  Fotografia - sem vlož svoju fotografiu, ktorá sa bude zobrazovať pri tvojom profile kandidáta. Dávaj pozor na výber, lebo aj fotografia naznačuje niečo o osobnosti na fotografii
                </span>
              </v-tooltip>
              <v-img
                v-if="form.photo"
                class="my-5"
                :src="form.photo"
              />

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-file-input
                    data-test="video-file-input"
                    v-model="video_file"
                    accept="video/*"
                    label="Video - sem nahraj svoj videosľub"
                    v-bind="attrs"
                    v-on="on"
                    @mouseenter.native="on.mouseenter"
                    @mouseleave.native="on.mouseleave"
                  ></v-file-input>
                </template>
                <span>
                  Video - sem nahraj svoj videosľub
                </span>
              </v-tooltip>

              <div
                v-if="videoPreviewUrl"
                class="text-center"
              >
                <video
                  data-test="video-local-preview"
                  :src="videoPreviewUrl"
                  width="500"
                  controls
                  preload="metadata"
                  playsinline
                >
                  Your browser does not support the video tag.
                </video>
              </div>
              <candidate-video
                v-else-if="form.video || form.video_webm"
                :mp4="form.video"
                :webm="form.video_webm"
                :reload-key="form.updated_at || form.video_status"
                width="500"
              />

              <v-alert
                v-if="['pending', 'processing'].includes(form.video_status)"
                data-test="video-processing-alert"
                type="info"
                dense
              >
                Video sa spracúva. Môže to chvíľu trvať.
              </v-alert>
              <v-alert
                v-else-if="form.video_status === 'failed'"
                data-test="video-failed-alert"
                type="warning"
                role="alert"
                dense
              >
                Spracovanie videa zlyhalo. Nahraj nový súbor alebo kontaktuj administrátora.
              </v-alert>
              <div v-if="hasServerVideo">
                <v-btn
                  v-if="form.video_status === 'failed'"
                  data-test="video-retry"
                  color="primary"
                  text
                  :disabled="requestActive"
                  @click="retryVideo"
                >
                  Skúsiť spracovanie znova
                </v-btn>
                <v-btn
                  data-test="video-remove"
                  color="error"
                  text
                  :disabled="requestActive"
                  @click="removeVideo"
                >
                  Odstrániť video
                </v-btn>
              </div>

              <v-checkbox
                v-model="agreement"
                label="Súhlasím s podmienkami"
                name="agreement"
              >
              </v-checkbox>

              <g-d-p-r-consent v-model="agreement_gdpr"></g-d-p-r-consent>

              <v-card-actions>
                <v-spacer />
                <v-btn
                  data-test="candidate-submit"
                  :disabled="requestActive || !agreement || !agreement_gdpr"
                  color="primary"
                  @click="create"
                >
                  <span> Odoslať žiadosť </span>
                </v-btn>
                <v-progress-circular
                  v-if="loading"
                  indeterminate
                  color="success"
                ></v-progress-circular>
              </v-card-actions>
            </v-card-text>
            <v-card-text
              v-else-if="initialLoading"
              data-test="candidate-initial-loading"
              class="text-center"
            >
              <v-progress-circular
                indeterminate
                color="success"
              ></v-progress-circular>
            </v-card-text>
            <v-card-text v-else-if="!user.verified">
              Kandidovať môžeš až po aktivácii svojho používateľského účtu.
            </v-card-text>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
    <v-snackbar
      v-model="snackbar_saved"
      color="success"
      :timeout="10000"
    >
      Tvoja ŽIADOSŤ bola úspešne odoslaná. Po schválení jej obsahu administrátorom bude tvoj pôvodný profil kandidáta nahradený týmto novým profilom po úprave.
      <v-btn
        text
        @click="snackbar_saved = false"
      >
        Zavrieť
      </v-btn>
    </v-snackbar>
    <v-snackbar
      v-model="snackbar_error"
      color="error"
      :timeout="10000"
    >
      Chyba
    </v-snackbar>

  </div>
</template>

<script>
import { APIService } from "@/http/APIService.js";
import { mapGetters } from "vuex";
import CandidateVideo from '../components/CandidateVideo.vue';
import GDPRConsent from '../components/GDPRConsent.vue';

const apiService = new APIService();
const CANDIDATE_VIDEO_FIELDS = ["video", "video_webm", "video_status"];

export default {
  props: {
    source: String,
  },

  components: {
    CandidateVideo,
    GDPRConsent,
  },

  data() {
    return {
      loading: true,
      initialLoading: true,
      initialLoadFailed: false,
      videoActionLoading: false,
      drawer: null,
      agreement: false,
      agreement_gdpr: false,

      photo_file: null,
      video_file: null,
      videoPreviewUrl: null,
      videoSelectionGeneration: 0,
      videoPollTimer: null,
      videoPollGeneration: 0,

      snackbar_saved: false,
      snackbar_error: false,

      user: {},
      form: {
        name: "",
        location: "",
        short_info: "",
        long_info: "",
        photo: null,
        video: null,
      },
    };
  },

  computed: {
    ...mapGetters("auth", ["isAuthenticated"]),
    requestActive() {
      return this.loading || this.videoActionLoading;
    },
    hasServerVideo() {
      return Boolean(
        this.form.id &&
        (
          this.form.video ||
          this.form.video_webm ||
          (this.form.video_status && this.form.video_status !== "none")
        )
      );
    },
  },

  watch: {
    video_file(file) {
      this.videoSelectionGeneration += 1;
      this.releaseVideoPreview();
      if (file instanceof File) {
        this.videoPreviewUrl = URL.createObjectURL(file);
      }
    },
  },

  created() {
    this.videoComponentDestroyed = false;
  },

  mounted: function () {
    this.getMe();
  },

  beforeDestroy() {
    this.videoComponentDestroyed = true;
    this.cleanupVideoState();
  },

  beforeRouteLeave(to, from, next) {
    this.cleanupVideoState();
    next();
  },

  methods: {
    async getMe() {
      this.loading = true;
      this.initialLoading = true;
      this.initialLoadFailed = false;
      try {
        const response = await apiService.getMe();
        if (this.videoComponentDestroyed) return;
        this.user = response;
        if (this.user.candidate_id != null) {
          const generation = this.videoPollGeneration;
          const candidate = await apiService.getUserCandidate(
            this.user.candidate_id,
            { suppressErrorAlert: true },
          );
          if (
            !this.videoComponentDestroyed &&
            generation === this.videoPollGeneration
          ) this.applyCandidate(candidate);
        }
      } catch (error) {
        if (!this.videoComponentDestroyed) {
          this.initialLoadFailed = true;
          this.snackbar_error = true;
        }
      } finally {
        if (!this.videoComponentDestroyed) {
          this.loading = false;
          this.initialLoading = false;
        }
      }
    },

    applyCandidate(response) {
      this.form = response;
      this.startVideoPolling();
    },

    applyVideoState(response) {
      const videoState = CANDIDATE_VIDEO_FIELDS.reduce((state, field) => {
        if (Object.prototype.hasOwnProperty.call(response, field)) {
          state[field] = response[field];
        }
        return state;
      }, {});
      this.form = { ...this.form, ...videoState };
    },

    startVideoPolling() {
      this.stopVideoPolling();
      if (!["pending", "processing"].includes(this.form.video_status)) return;
      this.scheduleVideoPoll(this.videoPollGeneration, this.form.id);
    },

    scheduleVideoPoll(generation, candidateId) {
      this.videoPollTimer = setTimeout(() => {
        this.videoPollTimer = null;
        this.pollVideoStatus(generation, candidateId);
      }, 3000);
    },

    async pollVideoStatus(generation, candidateId) {
      try {
        const response = await apiService.getUserCandidate(candidateId, {
          suppressErrorAlert: true,
        });
        if (
          this.videoComponentDestroyed ||
          generation !== this.videoPollGeneration ||
          this.form.id !== candidateId
        ) return;
        this.applyVideoState(response);
        if (["pending", "processing"].includes(this.form.video_status)) {
          this.scheduleVideoPoll(generation, candidateId);
        } else {
          this.stopVideoPolling();
        }
      } catch (error) {
        if (
          !this.videoComponentDestroyed &&
          generation === this.videoPollGeneration &&
          this.form.id === candidateId
        ) {
          if (this.shouldRetryVideoPoll(error)) {
            this.scheduleVideoPoll(generation, candidateId);
          } else {
            this.stopVideoPolling();
          }
        }
      }
    },

    shouldRetryVideoPoll(error) {
      const status = error && error.response
        ? error.response.status
        : null;
      if (status === null || status === undefined) return true;
      return [408, 425, 429].includes(status) || status >= 500;
    },

    stopVideoPolling() {
      if (this.videoPollTimer !== null) clearTimeout(this.videoPollTimer);
      this.videoPollTimer = null;
      this.videoPollGeneration += 1;
    },

    releaseVideoPreview() {
      if (this.videoPreviewUrl) URL.revokeObjectURL(this.videoPreviewUrl);
      this.videoPreviewUrl = null;
    },

    cleanupVideoState() {
      this.stopVideoPolling();
      this.releaseVideoPreview();
    },

    isVideoGenerationCurrent(generation) {
      return (
        !this.videoComponentDestroyed &&
        generation === this.videoPollGeneration
      );
    },

    async retryVideo() {
      if (
        this.requestActive ||
        this.form.video_status !== "failed" ||
        !this.form.id
      ) return;
      this.stopVideoPolling();
      const generation = this.videoPollGeneration;
      this.videoActionLoading = true;
      try {
        const response = await apiService.retryUserCandidateVideo(this.form.id);
        if (!this.isVideoGenerationCurrent(generation)) return;
        this.applyVideoState(response);
        this.startVideoPolling();
      } catch (error) {
        if (this.isVideoGenerationCurrent(generation)) this.snackbar_error = true;
      } finally {
        this.videoActionLoading = false;
      }
    },

    async removeVideo() {
      if (this.requestActive || !this.hasServerVideo) return;
      this.stopVideoPolling();
      const generation = this.videoPollGeneration;
      this.videoActionLoading = true;
      try {
        const response = await apiService.removeUserCandidateVideo(this.form.id);
        if (!this.isVideoGenerationCurrent(generation)) return;
        this.releaseVideoPreview();
        this.video_file = null;
        this.applyVideoState(response);
        this.startVideoPolling();
      } catch (error) {
        if (this.isVideoGenerationCurrent(generation)) {
          this.snackbar_error = true;
          this.startVideoPolling();
        }
      } finally {
        this.videoActionLoading = false;
      }
    },

    async create() {
      if (this.requestActive) return;
      if (!confirm("Naozaj chcete odoslať žiadosť?")) return;
      this.stopVideoPolling();
      const generation = this.videoPollGeneration;
      const submittedVideoFile = this.video_file;
      const submittedVideoSelectionGeneration = this.videoSelectionGeneration;
      this.loading = true;

      let formData = new FormData();

      for (var key in this.form) {
        if (key == "photo") continue;
        if (key == "video") continue;

        if (this.form[key] != null) formData.set(key, this.form[key]);
      }

      // if (this.photo_file == null) formData.append("photo", "");
      // if (this.video_file == null) formData.append("video", "");

      if (this.photo_file instanceof File)
        formData.append("photo", this.photo_file);

      if (this.video_file instanceof File)
        formData.append("video", this.video_file);

      formData.append("user", this.user.id);

      try {
        const response = this.user.candidate_id
          ? await apiService.updateUserCandidate(
            formData,
            this.form.id || this.user.candidate_id,
          )
          : await apiService.createUserCandidate(formData);
        if (!this.isVideoGenerationCurrent(generation)) return;
        if (
          this.videoSelectionGeneration === submittedVideoSelectionGeneration &&
          this.video_file === submittedVideoFile
        ) {
          this.releaseVideoPreview();
          this.video_file = null;
        }
        this.user.candidate_id = response.id;
        this.user.candidate_approved = false;
        this.form = { ...this.form, id: response.id };
        this.applyVideoState(response);
        this.startVideoPolling();
        this.snackbar_saved = true;
      } catch (error) {
        if (this.isVideoGenerationCurrent(generation)) {
          this.snackbar_error = true;
          this.startVideoPolling();
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
